import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    postPackage (familyEditionId, type, data) {
        return httpService.post(ApiEndpoints.get('specialist_package', { familyEditionId, type }), data);
    },
    getPackage (familyEditionId, type) {
        return httpService.get(ApiEndpoints.get('specialist_package', { familyEditionId, type }));
    },
    saveDraft (familyEditionId, type, data) {
        return httpService.post(
            ApiEndpoints.get('specialist_package_draft', { familyEditionId, type }),
            data
        );
    },
    getDraft (familyEditionId, type) {
        return httpService.get(ApiEndpoints.get('specialist_package_draft', { familyEditionId, type }));
    },
    removeDraft (familyEditionId, type) {
        return httpService.delete(
            ApiEndpoints.get('specialist_package_draft', { familyEditionId, type })
        );
    }
};
